import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseQuestionComponent } from '../base-question.component';

/**
 * Toggle question component.
 * Displays and configures a toggle/switch question.
 * Uses Angular signals inherited from BaseQuestionComponent.
 */
@Component({
  selector: 'app-toggle-question',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './toggle-question.component.html',
  styleUrl: './toggle-question.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToggleQuestionComponent extends BaseQuestionComponent implements OnInit {
  falseLabel: string = 'Off';
  trueLabel: string = 'On';

  ngOnInit(): void {
    const q = this.question();
    // Initialize labels from question model or use defaults
    if (q.toggleLabels && q.toggleLabels.length === 2) {
      this.falseLabel = q.toggleLabels[0] || 'Off';
      this.trueLabel = q.toggleLabels[1] || 'On';
    }
  }

  onLabelChange(value: string): void {
    this.updateLabel(value);
  }

  onHelperTextChange(value: string): void {
    this.updateHelperText(value);
  }

  onAdditionalInfoChange(value: string): void {
    this.updateAdditionalInfo(value);
  }

  onFalseLabelChange(value: string): void {
    this.falseLabel = value;
    this.saveToggleLabels();
  }

  onTrueLabelChange(value: string): void {
    this.trueLabel = value;
    this.saveToggleLabels();
  }

  private saveToggleLabels(): void {
    const toggleLabels: [string, string] = [
      this.falseLabel.trim() || 'Off',
      this.trueLabel.trim() || 'On'
    ];
    this.emitConfigChange({ toggleLabels } as any);
    this.emitQuestionChange({ ...this.question(), toggleLabels });
  }

  onRequiredToggle(): void {
    this.updateRequired(!this.question().isRequired);
  }
}
